var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        ref: "plantDocuDetail",
        attrs: {
          type: "horizon",
          height: _vm.tabHeight,
          tabItems: _vm.tabItems,
          dense: true,
          inlineLabel: true,
        },
        on: {
          "update:tabItems": function ($event) {
            _vm.tabItems = $event
          },
          "update:tab-items": function ($event) {
            _vm.tabItems = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  tag: "component",
                  attrs: {
                    param: _vm.popupParam,
                    contentHeight: _vm.contentHeight,
                  },
                  on: {
                    changeStatus: _vm.changeStatus,
                    transInfo: _vm.transInfo,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }